import { useMemo, useState } from 'react';
import objectPath from 'object-path';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useHtmlClassService } from '..';
import { toAbsoluteUrl } from '../../../utils/helpers';
import { AsideMenu } from './aside-menu/AsideMenu';
import { Brand } from '../brand/Brand';
import { NavLink, useNavigate } from 'react-router-dom';
import { FaBox, FaChartBar, FaCreditCard, FaSignOutAlt, FaUser, FaUserAstronaut, FaUserShield } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import { actions } from '../../../store/authentication/AuthSlice';
import { hasAccessRight } from '../../../utils/Functions';
import { AdminAclEnum } from '../../../enum/AdminAclEnum';
import generalSlice from '../../../store/general/GeneralSlice';
import { TbLetterM } from 'react-icons/tb';

export function Aside() {
    const uiService = useHtmlClassService();
    const layoutProps = useMemo(() => {
        return {
            asideClassesFromConfig: uiService.getClasses('aside', true),
            asideSecondaryDisplay: objectPath.get(uiService.config, 'aside.secondary.display'),
            asideSelfMinimizeToggle: objectPath.get(uiService.config, 'aside.self.minimize.toggle'),
            extrasSearchDisplay: objectPath.get(uiService.config, 'extras.search.display'),
            extrasNotificationsDisplay: objectPath.get(uiService.config, 'extras.notifications.display'),
            extrasQuickActionsDisplay: objectPath.get(uiService.config, 'extras.quick-actions.display'),
            extrasQuickPanelDisplay: objectPath.get(uiService.config, 'extras.quick-panel.display'),
            extrasLanguagesDisplay: objectPath.get(uiService.config, 'extras.languages.display'),
            extrasUserDisplay: objectPath.get(uiService.config, 'extras.user.display'),
        };
    }, [uiService]);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const tabs = {
        tabId1: 'kt_aside_tab_1',
        tabId2: 'kt_aside_tab_2',
    };

    // const handleTabChange = (id) => {
    //     setActiveTab(id);
    //     const asideWorkspace = KTUtil.find(
    //         document.getElementById("kt_aside"),
    //         ".aside-secondary .aside-workspace"
    //     );
    //     if (asideWorkspace) {
    //         KTUtil.scrollUpdate(asideWorkspace);
    //     }
    // };

    const [activeTab] = useState(tabs.tabId1);

    const logout = () => {
        dispatch(generalSlice.actions.setConfirmModal({ show: false }));
        dispatch(actions.logout());
        localStorage.clear();
        navigate('/');
    };

    return (
        <div id="kt_aside" className={`aside aside-left d-flex ${layoutProps.asideClassesFromConfig}`}>
            <div className="aside-primary d-flex flex-column align-items-center flex-row-auto">
                <Brand />

                <div className="aside-nav d-flex flex-column align-items-center justify-content-between flex-column-fluid pt-5 scroll scroll-pull">
                    <ul className="list-unstyled flex-column" role="tablist">
                        <li className="nav-item mb-3" title="Dashboard Card">
                            <OverlayTrigger
                                placement="right"
                                overlay={<Tooltip id="latest-project">Dashboard Card</Tooltip>}
                            >
                                <NavLink to="/" className="nav-link btn btn-icon btn-clean btn-lg">
                                    <span className="svg-icon svg-icon-lg">
                                        <img
                                            alt="layout-icon"
                                            src={toAbsoluteUrl('/media/icons/Layout/Layout-4-blocks.svg')}
                                        />
                                    </span>
                                </NavLink>
                            </OverlayTrigger>
                        </li>
                        {hasAccessRight(AdminAclEnum.USERS) && (
                            <li className="nav-item mb-3" title="Users">
                                <OverlayTrigger
                                    placement="right"
                                    overlay={<Tooltip id="metronic-features">Users</Tooltip>}
                                >
                                    <NavLink to="/user" className={`nav-link btn btn-icon btn-clean btn-lg`}>
                                        <span className="svg-icon svg-icon-lg">
                                            <FaUser />
                                        </span>
                                    </NavLink>
                                </OverlayTrigger>
                            </li>
                        )}

                        {hasAccessRight(AdminAclEnum.CAMPAIGNS) && (
                            <li className="nav-item mb-3" title="Campaigns">
                                <OverlayTrigger
                                    placement="right"
                                    overlay={<Tooltip id="metronic-features">Campaigns</Tooltip>}
                                >
                                    <NavLink to="/campaign/list" className={`nav-link btn btn-icon btn-clean btn-lg`}>
                                        <span className="svg-icon svg-icon-lg">
                                            <FaBox />
                                        </span>
                                    </NavLink>
                                </OverlayTrigger>
                            </li>
                        )}
                        {hasAccessRight(AdminAclEnum.REPORTING) && (
                            <li className="nav-item mb-3" title="Latest Reports">
                                <OverlayTrigger
                                    placement="right"
                                    overlay={<Tooltip id="latest-reports">Reporting</Tooltip>}
                                >
                                    <NavLink
                                        to="/reporting/overview"
                                        className="nav-link btn btn-icon btn-clean btn-lg"
                                    >
                                        <span className="svg-icon svg-icon-lg">
                                            <FaChartBar />
                                        </span>
                                    </NavLink>
                                </OverlayTrigger>
                            </li>
                        )}
                        {hasAccessRight(AdminAclEnum.BUDGET) && (
                            <li className="nav-item mb-3" title="Budget overview">
                                <OverlayTrigger
                                    placement="right"
                                    overlay={<Tooltip id="latest-reports">Budget overview</Tooltip>}
                                >
                                    <NavLink to="/campaign/budget" className="nav-link btn btn-icon btn-clean btn-lg">
                                        <span className="svg-icon svg-icon-lg">
                                            <FaCreditCard />
                                        </span>
                                    </NavLink>
                                </OverlayTrigger>
                            </li>
                        )}
                        {hasAccessRight(AdminAclEnum.INFLUENCERS) && (
                            <li className="nav-item mb-3" title="Budget overview">
                                <OverlayTrigger
                                    placement="right"
                                    overlay={<Tooltip id="latest-reports">Influencers</Tooltip>}
                                >
                                    <NavLink
                                        to="/user/influencers"
                                        className={`nav-link btn btn-icon btn-clean btn-lg`}
                                    >
                                        <span className="svg-icon svg-icon-lg">
                                            <FaUserAstronaut />
                                        </span>
                                    </NavLink>
                                </OverlayTrigger>
                            </li>
                        )}
                        {hasAccessRight(AdminAclEnum.ADMIN) && (
                            <li className="nav-item mb-3" title="Admins">
                                <OverlayTrigger
                                    placement="right"
                                    overlay={<Tooltip id="latest-reports">Admins</Tooltip>}
                                >
                                    <NavLink to="/admins" className={`nav-link btn btn-icon btn-clean btn-lg`}>
                                        <span className="svg-icon svg-icon-lg">
                                            <FaUserShield />
                                        </span>
                                    </NavLink>
                                </OverlayTrigger>
                            </li>
                        )}
                        {hasAccessRight(AdminAclEnum.MODASH_CHECK) && (
                            <li className="nav-item mb-3" title="Modash health">
                                <OverlayTrigger
                                    placement="right"
                                    overlay={<Tooltip id="latest-reports">Modash health</Tooltip>}
                                >
                                    <NavLink to="/modash" className={`nav-link btn btn-icon btn-clean btn-lg`}>
                                        <span className="svg-icon svg-icon-lg">
                                            <TbLetterM />
                                        </span>
                                    </NavLink>
                                </OverlayTrigger>
                            </li>
                        )}
                    </ul>

                    <div className="mb-6">
                        <OverlayTrigger placement="right" overlay={<Tooltip id="sign-out">Sign out</Tooltip>}>
                            <button
                                type="button"
                                onClick={() =>
                                    dispatch(
                                        generalSlice.actions.setConfirmModal({
                                            show: true,
                                            title: 'Sign out',
                                            contentBody: <div>Are you sure you want to sign out?</div>,
                                            action: logout,
                                        })
                                    )
                                }
                                className="nav-link btn btn-icon btn-clean btn-lg text-danger"
                            >
                                <span className="svg-icon svg-icon-lg">
                                    <FaSignOutAlt color="#f64e60" />
                                </span>
                            </button>
                        </OverlayTrigger>
                    </div>
                </div>

                <div className="aside-footer d-flex flex-column align-items-center flex-column-auto py-4 py-lg-10">
                    {layoutProps.asideSecondaryDisplay && layoutProps.asideSelfMinimizeToggle && (
                        <>
                            <OverlayTrigger
                                transition={false}
                                placement="right"
                                overlay={<Tooltip id="toggle-aside">Toggle Aside</Tooltip>}
                            >
                                <span
                                    className="aside-toggle btn btn-icon btn-primary btn-hover-primary shadow-sm"
                                    id="kt_aside_toggle"
                                >
                                    <i className="ki ki-bold-arrow-back icon-sm" />
                                </span>
                            </OverlayTrigger>
                        </>
                    )}
                </div>
            </div>

            {layoutProps.asideSecondaryDisplay && (
                <>
                    <div className="aside-secondary d-flex flex-row-fluid">
                        <div className="aside-workspace scroll scroll-push my-2">
                            <div className="tab-content">
                                <AsideMenu isActive={activeTab === tabs.tabId1} />
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}
